import { Component, ViewChild } from "@angular/core";
import { MatDialogRef } from "@angular/material/dialog";
import { TranslationLoaderService } from "src/app/core/service/translation-loader.service";
import { CreditCardFormComponent } from "./credit-card-form/credit-card-form.component";
import { locale as english } from "./i18n/en-US";
import { locale as spanish } from "./i18n/es-ES";
import { locale as portuguese } from "./i18n/pt-BR";

@Component({
    selector: "app-new-credit-card-dialog",
    templateUrl: "./new-credit-card-dialog.component.html",
    styleUrls: ["./new-credit-card-dialog.component.scss"]
})
export class NewCreditCardDialogComponent {
    _loading: boolean;

    @ViewChild("newPaymentCreditCardForm", { static: true })
    newPaymentCreditCardForm: CreditCardFormComponent;

    error: string;

    constructor(
        private _dialogRef: MatDialogRef<CreditCardFormComponent>,
        private _translationLoaderService: TranslationLoaderService
    ) {
        this._loading = false;
        this.error = null;
        this._translationLoaderService.loadTranslations(english, portuguese, spanish);
    }

    public clear(): void {
        this.newPaymentCreditCardForm.clear();
        this._loading = false;
        this.error = null;
    }
}
